import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    label: {
        '.lightTheme &': {
            color: '#222'
        },
        fontSize: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '7px'
    },
    value: {
        '.lightTheme &': {
            color: '#222'
        },
        fontSize: '10px',
        fontWeight: '600'
    }
}